import Service from "./Service";

export default class JunkSizeMailService extends Service {
    constructor() {
        super();
    }

    sendJunkSizeEmail(data) {
        return this.axios.post('/junk-size-mail', data)
    }
}